webpackJsonp([15],{

/***/ 1114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationsReassign_vue__ = __webpack_require__(1265);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d983eb7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationsReassign_vue__ = __webpack_require__(1408);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationsReassign_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d983eb7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationsReassign_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridTable_vue__ = __webpack_require__(1136);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b00a312_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridTable_vue__ = __webpack_require__(1141);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b00a312_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'GridTable',
  components: {
    Draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a
  },
  props: {
    columns: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    sort: {
      type: String,
      default: null
    },
    direction: {
      type: String,
      default: 'asc'
    },
    emptyText: {
      type: String,
      default: null
    },
    openId: {
      type: [String, Number],
      default: undefined
    },
    draggable: {
      type: Boolean,
      default: false
    },

    /**
     * Opt-in grouped drag mode (with `draggable`): [{ id, units: [{ row, children: [] }] }].
     * The row's `cell:*` slot decides who may be dragged by putting `gt__drag-handle--group`
     * (moves the whole group) or `gt__drag-handle--child` (reorders inside its own unit) on
     * the handle element. `rows` is then rendered below as plain, non-draggable rows.
     * Emits `drag-end` with the flat ordered ids of everything inside the groups.
     */
    groups: {
      type: Array,
      default: null
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    noBorders: {
      type: Boolean,
      default: false
    },
    noStripes: {
      type: Boolean,
      default: false
    },
    borderMode: {
      type: String,
      default: null
    },
    borderColor: {
      type: String,
      default: null
    },
    borderWidth: {
      type: String,
      default: null
    },
    rowBg: {
      type: String,
      default: null
    },
    tabAlignTop: {
      type: Boolean,
      default: false
    },
    mobBreak: {
      type: Number,
      default: 575
    },
    tabBreak: {
      type: Number,
      default: 767
    }
  },
  setup: function setup(props) {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var root = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var isMob = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var isTab = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var internalOpenId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var ro = null;
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      ro = new ResizeObserver(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
            entry = _ref2[0];

        var w = entry.contentRect.width;
        isMob.value = w <= props.mobBreak;
        isTab.value = !isMob.value && w <= props.tabBreak;
      });
      ro.observe(root.value);
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["j" /* onUnmounted */])(function () {
      if (ro) ro.disconnect();
    });
    var cachedRows = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])([function () {
      return props.rows;
    }, function () {
      return props.loading;
    }], function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          rows = _ref4[0],
          loading = _ref4[1];

      if (!loading) cachedRows.value = rows;
    }, {
      immediate: true
    });
    var displayRows = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.loading ? cachedRows.value : props.rows;
    }); // Local mutable copy: vuedraggable splices the arrays it is given in place.

    var groupList = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(function () {
      return props.groups;
    }, function (groups) {
      groupList.value = (groups || []).map(function (group) {
        return _objectSpread({}, group, {
          units: group.units.map(function (unit) {
            return _objectSpread({}, unit, {
              children: _toConsumableArray(unit.children)
            });
          })
        });
      });
    }, {
      immediate: true
    }); // Row position across all groups, so stripes alternate row by row exactly like the plain table.

    var groupRowIndex = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var index = {};
      var n = 0;
      groupList.value.forEach(function (group) {
        return group.units.forEach(function (unit) {
          index[unit.row.id] = n++;
          unit.children.forEach(function (child) {
            index[child.id] = n++;
          });
        });
      });
      return index;
    });
    var groupRowCount = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return Object.keys(groupRowIndex.value).length;
    }); // Second argument: the id of the row that was dragged (a group's first row, or the child row), so
    // the page can show the result of the reorder next to it.

    function onGroupDragEnd(evt) {
      var ids = groupList.value.flatMap(function (group) {
        return group.units.flatMap(function (unit) {
          return [unit.row.id].concat(_toConsumableArray(unit.children.map(function (child) {
            return child.id;
          })));
        });
      });
      var item = evt && evt.item;
      var holder = item && (item.dataset.rowId != null ? item : item.querySelector('[data-row-id]'));
      var movedId = holder ? Number(holder.dataset.rowId) : null;
      proxy.$emit('drag-end', ids, Number.isNaN(movedId) ? null : movedId);
    }

    var resolvedOpenId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.openId !== undefined ? props.openId : internalOpenId.value;
    });

    function toggleRow(id) {
      if (props.openId !== undefined) return;
      internalOpenId.value = internalOpenId.value === id ? null : id;
    }

    function colTrack(col) {
      var widthKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'width';
      var w = col[widthKey] || col.width || 'max-content';
      return col.minWidth ? "minmax(".concat(col.minWidth, ", ").concat(w, ")") : w;
    }

    var cssVars = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var vars = {
        '--gt-cols': props.columns.map(function (c) {
          return colTrack(c);
        }).join(' '),
        '--gt-cols-mob': props.columns.filter(function (c) {
          return !c.mobile;
        }).map(function (c) {
          return colTrack(c, 'mobileWidth');
        }).join(' '),
        '--gt-cols-tab': props.columns.filter(function (c) {
          return !c.tabRow && c.tablet !== 'hide' && c.tablet !== 'wrap';
        }).map(function (c) {
          return colTrack(c, 'tabWidth');
        }).join(' ')
      };
      if (props.borderColor != null) vars['--gt-border-color'] = props.borderColor;
      if (props.borderWidth != null) vars['--gt-border-width'] = props.borderWidth;
      if (props.rowBg != null) vars['--gt-row-bg'] = props.rowBg;
      return vars;
    });
    var mobileLabelCols = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.columns.filter(function (c) {
        return c.mobile === 'label';
      });
    });
    var primaryIdx = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var explicit = props.columns.findIndex(function (c) {
        return c.primary;
      });
      return explicit !== -1 ? explicit : props.columns.findIndex(function (c) {
        return !c.mobile;
      });
    });
    var hasExpand = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return 'expand' in proxy.$scopedSlots;
    });

    function mobClass(col) {
      if (!col.mobile) return null;
      return col.mobile === 'label' ? 'gt__cell--mob-label' : 'gt__cell--mob-hide';
    }

    function tabHdrClass(col) {
      if (col.tablet === 'wrap' || col.tabRow) return 'gt__hdr--tab-wrap';
      if (col.tablet === 'hide') return 'gt__hdr--tab-hide';
      if (col.tabHideLabel) return 'gt__hdr--tab-no-label';
      return null;
    }

    function tabCellClass(col) {
      if (col.tablet === 'wrap' || col.tabRow) return 'gt__cell--tab-wrap';
      if (col.tablet === 'hide') return 'gt__cell--tab-hide';
      return null;
    }

    var tabWrapLayout = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var n = props.columns.filter(function (c) {
        return !c.tabRow && c.tablet !== 'hide' && c.tablet !== 'wrap';
      }).length;

      function calcRow(cols, row) {
        return cols.reduce(function (acc, col, i, arr) {
          var prevEnd = i === 0 ? 1 : acc[arr[i - 1].key].end;
          var isLast = i === arr.length - 1;
          var pct = col.tabletWidth ? parseFloat(col.tabletWidth) / 100 : 1 / arr.length;
          var span = isLast ? n + 1 - prevEnd : Math.max(1, Math.round(pct * n));
          acc[col.key] = {
            start: prevEnd,
            end: prevEnd + span,
            row: row
          };
          return acc;
        }, {});
      }

      var rowNumbers = _toConsumableArray(new Set(props.columns.map(function (c) {
        return c.tablet === 'wrap' ? 2 : c.tabRow;
      }).filter(function (row) {
        return row != null;
      })));

      return rowNumbers.reduce(function (acc, row) {
        var cols = props.columns.filter(function (c) {
          return (c.tablet === 'wrap' ? 2 : c.tabRow) === row;
        });
        return _objectSpread({}, acc, {}, calcRow(cols, row));
      }, {});
    });

    function tabCellStyle(col) {
      var pos = tabWrapLayout.value[col.key];
      if (!pos) return {};
      return {
        '--tab-col-start': pos.start,
        '--tab-col-end': pos.end,
        '--tab-row': pos.row
      };
    }

    var borderModeClass = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (!props.borderMode) return null;
      return "gt--border-".concat(props.borderMode);
    });
    return {
      root: root,
      isMob: isMob,
      isTab: isTab,
      displayRows: displayRows,
      groupList: groupList,
      groupRowIndex: groupRowIndex,
      groupRowCount: groupRowCount,
      onGroupDragEnd: onGroupDragEnd,
      resolvedOpenId: resolvedOpenId,
      toggleRow: toggleRow,
      cssVars: cssVars,
      mobileLabelCols: mobileLabelCols,
      primaryIdx: primaryIdx,
      hasExpand: hasExpand,
      mobClass: mobClass,
      tabHdrClass: tabHdrClass,
      tabCellClass: tabCellClass,
      tabCellStyle: tabCellStyle,
      borderModeClass: borderModeClass
    };
  }
}));

/***/ }),

/***/ 1141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",staticClass:"gt",class:[{ 'gt--mob': _vm.isMob, 'gt--tab': _vm.isTab, 'gt--tab-top': _vm.tabAlignTop, 'gt--loading': _vm.loading, 'gt--no-borders': _vm.noBorders, 'gt--no-stripes': _vm.noStripes }, _vm.borderModeClass],style:(_vm.cssVars)},[(_vm.loading)?_c('div',{staticClass:"table-overlay"},[_c('div',{staticClass:"table-spinner"})]):_vm._e(),_vm._v(" "),(!_vm.hideHeader)?_c('div',{staticClass:"gt__row gt__row--head"},_vm._l((_vm.columns),function(col){return _c('div',{key:col.key,staticClass:"gt__hdr",class:[_vm.mobClass(col), _vm.tabHdrClass(col), col.cellClass, { 'gt__hdr--sort': col.sortable }],on:{"click":function($event){col.sortable ? _vm.$emit('sort', col.key) : undefined}}},[_vm._v("\n      "+_vm._s(col.label)+"\n      "),(col.sortable)?_c('span',{staticClass:"sort-arrows"},[_c('span',{class:['sort-arrow sort-arrow--up', { active: _vm.sort === col.key && _vm.direction === 'asc' }]}),_vm._v(" "),_c('span',{class:['sort-arrow sort-arrow--down', { active: _vm.sort === col.key && _vm.direction === 'desc' }]})]):_vm._e()])}),0):_vm._e(),_vm._v(" "),(!_vm.loading && !_vm.displayRows.length && !_vm.groupList.length)?_c('div',{staticClass:"gt__empty"},[_vm._v("\n    "+_vm._s(_vm.emptyText || 'No results found.')+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.draggable && _vm.groups)?_c('draggable',{staticClass:"gt__draggable-body",attrs:{"tag":"div","list":_vm.groupList,"handle":".gt__drag-handle--group"},on:{"end":_vm.onGroupDragEnd}},_vm._l((_vm.groupList),function(group){return _c('div',{key:("g-" + (group.id)),staticClass:"gt__group",class:{ 'gt__group--single': group.units.length === 1 && !group.units[0].children.length }},[_vm._l((group.units),function(unit){return [(_vm.$scopedSlots['before-row'])?_c('div',{key:("before-" + (unit.row.id)),staticClass:"gt__before-row"},[_vm._t("before-row",null,{"row":unit.row})],2):_vm._e(),_vm._v(" "),_c('div',{key:String(unit.row.id),staticClass:"gt__row gt__row--data",class:{ 'gt__row--open': _vm.resolvedOpenId === unit.row.id, 'gt__row--odd': _vm.groupRowIndex[unit.row.id] % 2 === 0 },attrs:{"data-row-id":unit.row.id}},_vm._l((_vm.columns),function(col,i){return _c('div',{key:col.key,staticClass:"gt__cell",class:[_vm.mobClass(col), _vm.tabCellClass(col), col.cellClass, { 'gt__cell--tab-labeled': _vm.isTab && col.tabLabel, 'gt__cell--tab-top': col.tabAlignTop }],style:(_vm.tabCellStyle(col))},[(_vm.isTab && col.tabLabel)?_c('strong',{staticClass:"gt__tab-label"},[_vm._v(_vm._s(col.label))]):_vm._e(),_vm._v(" "),_vm._t(("cell:" + (col.key)),[_vm._v(_vm._s(unit.row[col.key]))],{"row":unit.row}),_vm._v(" "),(i === _vm.primaryIdx && _vm.mobileLabelCols.length)?_c('div',{staticClass:"gt__mob-labels"},_vm._l((_vm.mobileLabelCols),function(mc){return _c('div',{key:mc.key,staticClass:"gt__mob-label"},[_c('strong',[_vm._v(_vm._s(mc.label)+": ")]),_vm._v(" "),_vm._t(("cell:" + (mc.key)),[_vm._v(_vm._s(unit.row[mc.key]))],{"row":unit.row})],2)}),0):_vm._e()],2)}),0),_vm._v(" "),_c('draggable',{key:("u-" + (unit.row.id)),staticClass:"gt__draggable-body",attrs:{"tag":"div","list":unit.children,"group":("unit-" + (unit.row.id)),"handle":".gt__drag-handle--child"},on:{"end":_vm.onGroupDragEnd}},_vm._l((unit.children),function(child){return _c('div',{key:String(child.id),staticClass:"gt__row gt__row--data gt__row--child",class:{ 'gt__row--open': _vm.resolvedOpenId === child.id, 'gt__row--odd': _vm.groupRowIndex[child.id] % 2 === 0 },attrs:{"data-row-id":child.id}},_vm._l((_vm.columns),function(col,i){return _c('div',{key:col.key,staticClass:"gt__cell",class:[_vm.mobClass(col), _vm.tabCellClass(col), col.cellClass, { 'gt__cell--tab-labeled': _vm.isTab && col.tabLabel, 'gt__cell--tab-top': col.tabAlignTop }],style:(_vm.tabCellStyle(col))},[(_vm.isTab && col.tabLabel)?_c('strong',{staticClass:"gt__tab-label"},[_vm._v(_vm._s(col.label))]):_vm._e(),_vm._v(" "),_vm._t(("cell:" + (col.key)),[_vm._v(_vm._s(child[col.key]))],{"row":child}),_vm._v(" "),(i === _vm.primaryIdx && _vm.mobileLabelCols.length)?_c('div',{staticClass:"gt__mob-labels"},_vm._l((_vm.mobileLabelCols),function(mc){return _c('div',{key:mc.key,staticClass:"gt__mob-label"},[_c('strong',[_vm._v(_vm._s(mc.label)+": ")]),_vm._v(" "),_vm._t(("cell:" + (mc.key)),[_vm._v(_vm._s(child[mc.key]))],{"row":child})],2)}),0):_vm._e()],2)}),0)}),0)]})],2)}),0):_vm._e(),_vm._v(" "),(_vm.draggable && !_vm.groups)?_c('draggable',{staticClass:"gt__draggable-body",attrs:{"tag":"div","list":_vm.displayRows,"handle":".gt__drag-handle"},on:{"start":function($event){_vm.$emit('drag-start', _vm.displayRows.map(function (r) { return r.id; }))},"end":function($event){_vm.$emit('drag-end', _vm.displayRows.map(function (r) { return r.id; }))}}},_vm._l((_vm.displayRows),function(row,index){return _c('div',{key:String(row.id),staticClass:"gt__row gt__row--data",class:{ 'gt__row--open': _vm.resolvedOpenId === row.id, 'gt__row--odd': index % 2 === 0 }},_vm._l((_vm.columns),function(col,i){return _c('div',{key:col.key,staticClass:"gt__cell",class:[_vm.mobClass(col), _vm.tabCellClass(col), col.cellClass, { 'gt__cell--tab-labeled': _vm.isTab && col.tabLabel, 'gt__cell--tab-top': col.tabAlignTop }],style:(_vm.tabCellStyle(col))},[(_vm.isTab && col.tabLabel)?_c('strong',{staticClass:"gt__tab-label"},[_vm._v(_vm._s(col.label))]):_vm._e(),_vm._v(" "),_vm._t(("cell:" + (col.key)),[_vm._v(_vm._s(row[col.key]))],{"row":row}),_vm._v(" "),(i === _vm.primaryIdx && _vm.mobileLabelCols.length)?_c('div',{staticClass:"gt__mob-labels"},_vm._l((_vm.mobileLabelCols),function(mc){return _c('div',{key:mc.key,staticClass:"gt__mob-label"},[_c('strong',[_vm._v(_vm._s(mc.label)+": ")]),_vm._v(" "),_vm._t(("cell:" + (mc.key)),[_vm._v(_vm._s(row[mc.key]))],{"row":row})],2)}),0):_vm._e()],2)}),0)}),0):_vm._e(),_vm._v(" "),(!_vm.draggable || _vm.groups)?[_vm._l((_vm.displayRows),function(row,index){return [(_vm.$scopedSlots['before-row'])?_c('div',{key:("before-" + (row.id)),staticClass:"gt__before-row"},[_vm._t("before-row",null,{"row":row})],2):_vm._e(),_vm._v(" "),_c('div',{key:String(row.id),staticClass:"gt__row gt__row--data",class:{ 'gt__row--open': _vm.resolvedOpenId === row.id, 'gt__row--odd': (index + _vm.groupRowCount) % 2 === 0 }},_vm._l((_vm.columns),function(col,i){return _c('div',{key:col.key,staticClass:"gt__cell",class:[_vm.mobClass(col), _vm.tabCellClass(col), col.cellClass, { 'gt__cell--tab-labeled': _vm.isTab && col.tabLabel, 'gt__cell--tab-top': col.tabAlignTop }],style:(_vm.tabCellStyle(col))},[(_vm.isTab && col.tabLabel)?_c('strong',{staticClass:"gt__tab-label"},[_vm._v(_vm._s(col.label))]):_vm._e(),_vm._v(" "),_vm._t(("cell:" + (col.key)),[_vm._v(_vm._s(row[col.key]))],{"row":row,"toggle":function () { return _vm.toggleRow(row.id); },"isOpen":_vm.resolvedOpenId === row.id}),_vm._v(" "),(i === _vm.primaryIdx && _vm.mobileLabelCols.length)?_c('div',{staticClass:"gt__mob-labels"},_vm._l((_vm.mobileLabelCols),function(mc){return _c('div',{key:mc.key,staticClass:"gt__mob-label"},[_c('strong',[_vm._v(_vm._s(mc.label)+": ")]),_vm._v(" "),_vm._t(("cell:" + (mc.key)),[_vm._v(_vm._s(row[mc.key]))],{"row":row})],2)}),0):_vm._e()],2)}),0),_vm._v(" "),(_vm.hasExpand && _vm.resolvedOpenId === row.id)?_c('div',{key:("x-" + (row.id)),staticClass:"gt__expand"},[_vm._t("expand",null,{"row":row,"odd":(index + _vm.groupRowCount) % 2 === 0})],2):_vm._e()]})]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AppMultiselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Nominations_NominationReassignTabs__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Nominations_NominationEventTable__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__composables_nominations_useNominationsReassign__ = __webpack_require__(1407);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var TYPE_CONFIG = {
  member: {
    label: 'Competitor',
    optionLabel: 'full_name',
    toOptionLabel: 'full_name',
    toIdKey: 'to_member_id',
    toNoResultText: 'Only members linked to the below horses will show here'
  },
  horse: {
    label: 'Horse',
    optionLabel: 'name',
    toOptionLabel: 'name',
    toIdKey: 'to_horse_id',
    toNoResultText: 'Only horses linked to the below member will show here'
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'NominationsReassign',
  components: {
    TabLayout: __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */],
    PageHeading: __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_3__components_AppButton__["a" /* default */],
    AppMultiselect: __WEBPACK_IMPORTED_MODULE_4__components_AppMultiselect__["a" /* default */],
    NominationReassignTabs: __WEBPACK_IMPORTED_MODULE_5__components_Nominations_NominationReassignTabs__["a" /* default */],
    NominationEventTable: __WEBPACK_IMPORTED_MODULE_6__components_Nominations_NominationEventTable__["a" /* default */]
  },
  setup: function setup() {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var draftId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return proxy.$route.params.draftId;
    });
    var type = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return proxy.$route.params.type;
    });
    var typeLabel = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return TYPE_CONFIG[type.value].label;
    });
    var optionLabel = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return TYPE_CONFIG[type.value].optionLabel;
    });
    var toOptionLabel = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return TYPE_CONFIG[type.value].toOptionLabel;
    });
    var toNoResultText = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return TYPE_CONFIG[type.value].toNoResultText;
    });
    var form = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])({
      from: null,
      to: null
    });
    var selectedIds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
    var submitting = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

    var _useNominationsReassi = Object(__WEBPACK_IMPORTED_MODULE_7__composables_nominations_useNominationsReassign__["a" /* default */])(draftId, type),
        candidates = _useNominationsReassi.candidates,
        candidatesLoading = _useNominationsReassi.candidatesLoading,
        sourceEvents = _useNominationsReassi.sourceEvents,
        toOptions = _useNominationsReassi.toOptions,
        toLoading = _useNominationsReassi.toLoading,
        fetchCandidates = _useNominationsReassi.fetchCandidates,
        fetchSource = _useNominationsReassi.fetchSource,
        searchTo = _useNominationsReassi.searchTo,
        reassign = _useNominationsReassi.reassign;

    var canSubmit = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return form.from != null && form.to != null && selectedIds.value.length > 0;
    });
    var combPairMap = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var map = {};
      sourceEvents.value.forEach(function (event) {
        (event.nominations || []).forEach(function (n) {
          if (n.combNominationId != null) map[n.id] = n.combNominationId;
        });
      });
      return map;
    });

    function toggleNomination(id, checked) {
      var pairId = combPairMap.value[id];
      var ids = pairId != null ? [id, pairId] : [id];

      if (checked) {
        var toAdd = ids.filter(function (i) {
          return selectedIds.value.indexOf(i) === -1;
        });
        selectedIds.value = selectedIds.value.concat(toAdd);
      } else {
        selectedIds.value = selectedIds.value.filter(function (i) {
          return ids.indexOf(i) === -1;
        });
      }
    }

    function resetForm() {
      form.from = null;
      form.to = null;
      selectedIds.value = [];
      sourceEvents.value = [];
      toOptions.value = [];
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(type, function () {
      resetForm();
      fetchCandidates();
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(function () {
      return form.from;
    }, function (val) {
      form.to = null;
      selectedIds.value = [];
      toOptions.value = [];

      if (val != null) {
        fetchSource(val.id);
      } else {
        sourceEvents.value = [];
      }
    });

    function reloadSource() {
      if (form.from != null) fetchSource(form.from.id);
    }

    function onFromSearch(q) {
      fetchCandidates({
        q: q,
        page: 0
      });
    }

    function onToSearch(q) {
      if (form.from == null) return;
      searchTo({
        q: q,
        from_id: form.from.id
      });
    } // Secretary/admin hint: why an otherwise-unfinancial member is a valid target (CAM-1485)


    function toVolunteerNote(option) {
      if (option == null) return '';
      if (option.is_volunteer) return 'Volunteer';
      if (option.is_volunteer_family) return 'Volunteer family';
      return '';
    }

    function handleReassign() {
      return _handleReassign.apply(this, arguments);
    }

    function _handleReassign() {
      _handleReassign = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var config, payload, success;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (canSubmit.value) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                submitting.value = true;
                config = TYPE_CONFIG[type.value];
                payload = _defineProperty({
                  nomination_ids: selectedIds.value
                }, config.toIdKey, form.to.id);
                _context.next = 7;
                return reassign(payload);

              case 7:
                success = _context.sent;
                submitting.value = false;

                if (success) {
                  resetForm();
                  fetchCandidates();
                }

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _handleReassign.apply(this, arguments);
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      fetchCandidates();
    });
    return {
      draftId: draftId,
      type: type,
      typeLabel: typeLabel,
      optionLabel: optionLabel,
      toOptionLabel: toOptionLabel,
      toNoResultText: toNoResultText,
      form: form,
      selectedIds: selectedIds,
      submitting: submitting,
      canSubmit: canSubmit,
      candidates: candidates,
      candidatesLoading: candidatesLoading,
      sourceEvents: sourceEvents,
      toOptions: toOptions,
      toLoading: toLoading,
      onFromSearch: onFromSearch,
      onToSearch: onToSearch,
      toVolunteerNote: toVolunteerNote,
      toggleNomination: toggleNomination,
      reloadSource: reloadSource,
      handleReassign: handleReassign
    };
  }
}));

/***/ }),

/***/ 1266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'NominationReassignTabs',
  props: {
    draftId: {
      type: [String, Number],
      required: true
    },
    active: {
      type: String,
      default: 'member'
    }
  },
  setup: function setup(props) {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var navigate = function navigate(mode) {
      var path = mode === 'member' ? "/nominations/".concat(props.draftId, "/reassign-member") : "/nominations/".concat(props.draftId, "/reassign-horse");
      proxy.$router.push(path);
    };

    return {
      navigate: navigate
    };
  }
}));

/***/ }),

/***/ 1267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GridTable__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppCheckbox__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_EventBus__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api_nominations__ = __webpack_require__(437);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'NominationEventTable',
  components: {
    GridTable: __WEBPACK_IMPORTED_MODULE_1__components_GridTable__["a" /* default */],
    AppCheckbox: __WEBPACK_IMPORTED_MODULE_2__components_AppCheckbox__["a" /* default */]
  },
  props: {
    event: {
      type: Object,
      required: true
    },
    nominations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  emits: ['toggle', 'reload'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    // All nominations in a group belong to the same event, so the same event either
    // requires a horse for all rows or none — checking the first row is enough.
    var isNoHorseEvent = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.nominations.length > 0 && props.nominations[0].noHorse;
    });
    var tableColumns = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return [{
        key: 'select',
        label: '',
        width: '40px'
      }, {
        key: 'competitorName',
        label: 'Competitor name',
        width: '1fr'
      }, {
        key: 'horseName',
        label: isNoHorseEvent.value ? 'Quantity' : 'Horse name',
        width: '1fr'
      }, {
        key: 'paid',
        label: 'Payment status',
        width: '140px'
      }];
    }); // Remaining Quantity quota per nomination, keyed by nomination id — mirrors the backend's
    // per-person max_submissions check (this member's other quantities in this same event group,
    // capped at event.maxSubmissions). Same pattern as NominationsAddList.vue.

    var quantityMaxByNomId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var result = {};
      if (props.event.maxSubmissions == null) return result;
      var totalsByMember = {};
      props.nominations.forEach(function (n) {
        totalsByMember[n.userMemberId] = (totalsByMember[n.userMemberId] || 0) + (n.quantity || 0);
      });
      props.nominations.forEach(function (n) {
        result[n.id] = props.event.maxSubmissions - (totalsByMember[n.userMemberId] - (n.quantity || 0));
      });
      return result;
    });
    var quantityOverrides = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({});
    var quantityUpdatingIds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);

    function handleQuantityChange(_x, _x2) {
      return _handleQuantityChange.apply(this, arguments);
    }

    function _handleQuantityChange() {
      _handleQuantityChange = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(nomId, quantity) {
        var res, reverted, msg;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                quantityUpdatingIds.value = quantityUpdatingIds.value.concat(nomId);
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_api_nominations__["a" /* default */].updateNomination(nomId, {
                  quantity: quantity,
                  keep_original_status: true
                });

              case 4:
                res = _context.sent;
                if (res.data.message) __WEBPACK_IMPORTED_MODULE_3__store_EventBus__["a" /* default */].$emit('show-success', res.data.message);
                emit('reload');
                _context.next = 16;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                reverted = _objectSpread({}, quantityOverrides.value);
                delete reverted[nomId];
                quantityOverrides.value = reverted;
                msg = _context.t0.response != null && _context.t0.response.data != null ? _context.t0.response.data.message : 'Failed to update quantity';
                __WEBPACK_IMPORTED_MODULE_3__store_EventBus__["a" /* default */].$emit('http-error', msg);

              case 16:
                _context.prev = 16;
                quantityUpdatingIds.value = quantityUpdatingIds.value.filter(function (id) {
                  return id !== nomId;
                });
                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 9, 16, 19]]);
      }));
      return _handleQuantityChange.apply(this, arguments);
    }

    function onQuantityChange(nomId, value) {
      var quantity = Number(value);
      if (!Number.isInteger(quantity) || quantity < 1) return;
      var max = quantityMaxByNomId.value[nomId];
      if (max != null && quantity > max) quantity = max;
      quantityOverrides.value = _objectSpread({}, quantityOverrides.value, _defineProperty({}, nomId, quantity));
      handleQuantityChange(nomId, quantity);
    }

    return {
      tableColumns: tableColumns,
      quantityMaxByNomId: quantityMaxByNomId,
      quantityOverrides: quantityOverrides,
      quantityUpdatingIds: quantityUpdatingIds,
      onQuantityChange: onQuantityChange
    };
  }
}));

/***/ }),

/***/ 1401:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationReassignTabs_vue__ = __webpack_require__(1266);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_227b712e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationReassignTabs_vue__ = __webpack_require__(1402);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationReassignTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_227b712e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationReassignTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-inline mb-sm-3 d-flex align-items-end reports-container"},[_c('div',{staticClass:"d-flex col-12 col-md-auto px-0 mb-3 mb-md-2"},[_c('div',{staticClass:"filter pr-1"},[_c('div',{staticClass:"form-check pl-0"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":"reassignMode","id":"reassignModeCompetitor","value":"member"},domProps:{"checked":_vm.active === 'member'},on:{"change":function($event){return _vm.navigate('member')}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"reassignModeCompetitor"}},[_vm._v("Re-assign by competitor")])])]),_vm._v(" "),_c('div',{staticClass:"filter"},[_c('div',{staticClass:"form-check pl-0"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":"reassignMode","id":"reassignModeHorse","value":"horse"},domProps:{"checked":_vm.active === 'horse'},on:{"change":function($event){return _vm.navigate('horse')}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"reassignModeHorse"}},[_vm._v("Re-assign by horse")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationEventTable_vue__ = __webpack_require__(1267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b5dd080_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationEventTable_vue__ = __webpack_require__(1406);
function injectStyle (ssrContext) {
  __webpack_require__(1404)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b5dd080"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationEventTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b5dd080_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationEventTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1404:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1405);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("a67d6778", content, true, {});

/***/ }),

/***/ 1405:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".nomination-event-table__quantity-input[data-v-0b5dd080]{max-width:100px}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/Nominations/NominationEventTable.vue"],"names":[],"mappings":"AACA,yDACE,eAAiB,CAClB","file":"NominationEventTable.vue","sourcesContent":["\n.nomination-event-table__quantity-input[data-v-0b5dd080] {\n  max-width: 100px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nominations-list my-4"},[_c('strong',{staticClass:"event_name h5"},[_vm._v(_vm._s(_vm.event.name))]),_vm._v(" "),_c('grid-table',{attrs:{"columns":_vm.tableColumns,"rows":_vm.nominations,"hide-header":false,"no-stripes":""},scopedSlots:_vm._u([{key:"cell:select",fn:function(ref){
var row = ref.row;
return [_c('app-checkbox',{attrs:{"id":'reassign-' + row.id,"value":_vm.value.indexOf(row.id) !== -1},on:{"input":function($event){return _vm.$emit('toggle', row.id, $event)}}})]}},{key:"cell:competitorName",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.competitorName)+"\n      "),(row.competitorDeleted)?_c('small',{staticClass:"text-primary ml-1"},[_vm._v("(deleted)")]):_vm._e()]}},{key:"cell:horseName",fn:function(ref){
var row = ref.row;
return [(row.noHorse)?_c('input',{staticClass:"form-control nomination-event-table__quantity-input",attrs:{"type":"number","min":"1","max":_vm.quantityMaxByNomId[row.id],"disabled":_vm.quantityUpdatingIds.indexOf(row.id) !== -1},domProps:{"value":_vm.quantityOverrides[row.id] != null ? _vm.quantityOverrides[row.id] : row.quantity},on:{"change":function($event){return _vm.onQuantityChange(row.id, $event.target.value)}}}):[_vm._v(_vm._s(row.horseName))],_vm._v(" "),(row.horseDeleted)?_c('small',{staticClass:"text-primary ml-1"},[_vm._v("(deleted)")]):_vm._e(),_vm._v(" "),(row.combined)?_c('small',{staticClass:"text-primary ml-1"},[_vm._v("(Combined)")]):_vm._e()]}},{key:"cell:paid",fn:function(ref){
var row = ref.row;
return [_c('span',{class:row.paid ? 'text-success' : 'text-danger'},[_vm._v("\n        "+_vm._s(row.paid ? 'Paid' : 'Unpaid')+"\n      ")])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1407:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useNominationsReassign;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_EventBus__ = __webpack_require__(18);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




function useNominationsReassign(draftId, type) {
  var candidates = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var candidatesTotal = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(0);
  var candidatesLoading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var sourceEvents = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var sourceLoading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var toOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var toLoading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

  function fetchCandidates(_x) {
    return _fetchCandidates.apply(this, arguments);
  }

  function _fetchCandidates() {
    _fetchCandidates = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(params) {
      var res, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              candidatesLoading.value = true;
              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].getReassignCandidates(Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["o" /* unref */])(draftId), Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["o" /* unref */])(type), params);

            case 4:
              res = _context.sent;
              data = res.data.data;
              candidates.value = Array.isArray(data.items) ? data.items : [];
              candidatesTotal.value = data.total != null ? data.total : 0;
              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              candidates.value = [];
              candidatesTotal.value = 0;

            case 14:
              _context.prev = 14;
              candidatesLoading.value = false;
              return _context.finish(14);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10, 14, 17]]);
    }));
    return _fetchCandidates.apply(this, arguments);
  }

  function fetchSource(_x2) {
    return _fetchSource.apply(this, arguments);
  }

  function _fetchSource() {
    _fetchSource = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(sourceId) {
      var res;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              sourceLoading.value = true;
              _context2.prev = 1;
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].getReassignSource(Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["o" /* unref */])(draftId), Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["o" /* unref */])(type), sourceId);

            case 4:
              res = _context2.sent;
              sourceEvents.value = Array.isArray(res.data.data) ? res.data.data : [];
              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              sourceEvents.value = [];

            case 11:
              _context2.prev = 11;
              sourceLoading.value = false;
              return _context2.finish(11);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8, 11, 14]]);
    }));
    return _fetchSource.apply(this, arguments);
  }

  function searchTo(_x3) {
    return _searchTo.apply(this, arguments);
  }

  function _searchTo() {
    _searchTo = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(params) {
      var res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              toLoading.value = true;
              _context3.prev = 1;
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].searchReassign(Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["o" /* unref */])(draftId), Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["o" /* unref */])(type), params);

            case 4:
              res = _context3.sent;
              toOptions.value = Array.isArray(res.data.data) ? res.data.data : [];
              _context3.next = 11;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](1);
              toOptions.value = [];

            case 11:
              _context3.prev = 11;
              toLoading.value = false;
              return _context3.finish(11);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 8, 11, 14]]);
    }));
    return _searchTo.apply(this, arguments);
  }

  function reassign(_x4) {
    return _reassign.apply(this, arguments);
  }

  function _reassign() {
    _reassign = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4(data) {
      var res;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].reassign(Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["o" /* unref */])(draftId), Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["o" /* unref */])(type), data);

            case 3:
              res = _context4.sent;
              if (res.data.message) __WEBPACK_IMPORTED_MODULE_2__store_EventBus__["a" /* default */].$emit('show-success', res.data.message);
              return _context4.abrupt("return", true);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);

              if (_context4.t0.response && _context4.t0.response.data && _context4.t0.response.data.message) {
                __WEBPACK_IMPORTED_MODULE_2__store_EventBus__["a" /* default */].$emit('http-error', _context4.t0.response.data.message);
              }

              return _context4.abrupt("return", false);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 8]]);
    }));
    return _reassign.apply(this, arguments);
  }

  return {
    candidates: candidates,
    candidatesTotal: candidatesTotal,
    candidatesLoading: candidatesLoading,
    sourceEvents: sourceEvents,
    sourceLoading: sourceLoading,
    toOptions: toOptions,
    toLoading: toLoading,
    fetchCandidates: fetchCandidates,
    fetchSource: fetchSource,
    searchTo: searchTo,
    reassign: reassign
  };
}

/***/ }),

/***/ 1408:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"full-width":true}},[_c('div',{attrs:{"slot":"tabContent"},slot:"tabContent"},[_c('div',{staticClass:"bg-white rounded mb-4 p-3"},[_c('page-heading',[_vm._v("Re-assign nominations")]),_vm._v(" "),_c('div',{staticClass:"draft__info-block mb-3"},[_vm._v("\n        Please make sure the member you're trying to reassign to is linked to the horse and the horse is active.\n        "),_c('router-link',{attrs:{"to":"/secretary-horses"}},[_vm._v("Click HERE")]),_vm._v(" to view all horses in the ACA database and link members or make active\n      ")],1),_vm._v(" "),_c('nomination-reassign-tabs',{attrs:{"active":_vm.type,"draft-id":_vm.draftId}}),_vm._v(" "),_c('div',{staticClass:"default-form reassign-form"},[_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-6 col-md-3"},[_c('label',[_c('strong',[_vm._v("From "+_vm._s(_vm.typeLabel))])]),_vm._v(" "),_c('app-multiselect',{attrs:{"options":_vm.candidates,"placeholder":'Select ' + _vm.typeLabel.toLowerCase(),"label":_vm.optionLabel,"track-by":"id","internal-search":false,"loading":_vm.candidatesLoading},on:{"search-change":_vm.onFromSearch},model:{value:(_vm.form.from),callback:function ($$v) {_vm.$set(_vm.form, "from", $$v)},expression:"form.from"}})],1),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3"},[_c('label',[_c('strong',[_vm._v("To "+_vm._s(_vm.typeLabel))])]),_vm._v(" "),_c('app-multiselect',{attrs:{"options":_vm.toOptions,"placeholder":'Select ' + _vm.typeLabel.toLowerCase(),"label":_vm.toOptionLabel,"track-by":"id","internal-search":false,"loading":_vm.toLoading,"disabled":_vm.form.from == null},on:{"open":function($event){return _vm.onToSearch('')},"search-change":_vm.onToSearch},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
var option = ref.option;
return [_vm._v("\n                "+_vm._s(option[_vm.toOptionLabel])),(_vm.type === 'member' && _vm.$isSecretaryOrAdmin && _vm.toVolunteerNote(option))?_c('span',{staticClass:"text-muted"},[_vm._v(" ("+_vm._s(_vm.toVolunteerNote(option))+")")]):_vm._e()]}},{key:"option",fn:function(ref){
var option = ref.option;
return [_vm._v("\n                "+_vm._s(option[_vm.toOptionLabel])),(_vm.type === 'member' && _vm.$isSecretaryOrAdmin && _vm.toVolunteerNote(option))?_c('span',{staticClass:"text-muted"},[_vm._v(" ("+_vm._s(_vm.toVolunteerNote(option))+")")]):_vm._e()]}},{key:"noResult",fn:function(){return [_vm._v(_vm._s(_vm.toNoResultText))]},proxy:true}]),model:{value:(_vm.form.to),callback:function ($$v) {_vm.$set(_vm.form, "to", $$v)},expression:"form.to"}})],1)]),_vm._v(" "),_vm._l((_vm.sourceEvents),function(event){return _c('nomination-event-table',{key:event.id,attrs:{"event":event,"nominations":event.nominations,"value":_vm.selectedIds},on:{"toggle":_vm.toggleNomination,"reload":_vm.reloadSource}})}),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('app-button',{attrs:{"size":"sm","block":false,"disabled":!_vm.canSubmit,"loading":_vm.submitting},on:{"click":_vm.handleReassign}},[_vm._v("Reassign")])],1)],2)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/15.a4e63c8934242ef2e303.js